import React from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';

import ResponsiveToggleGroup from 'src/component/UI/ResponsiveToggleGroup';
import { useTranslation } from 'src/i18n/useTranslation';

import { getUnits } from 'src/module/filter/selector';

interface UnitSelectorProps {
  startDate?: moment.Moment | null;
  endDate?: moment.Moment | null;
  onStartDateChange?: ((date: moment.Moment | null) => void) | null;
  onEndDateChange?: ((date: moment.Moment | null) => void) | null;
}

export default function UnitSelector ({ startDate = null, endDate = null, onStartDateChange = null, onEndDateChange = null }: UnitSelectorProps) {
  const units = useSelector(getUnits);
  const { t } = useTranslation();

  return (
    <div data-testid='unit-selector'>
      <ResponsiveToggleGroup
        buttons={units}
        mainLabel={t('common.all')}
        startDate={startDate}
        endDate={endDate}
        onStartDateChange={onStartDateChange}
        onEndDateChange={onEndDateChange}
      />
    </div>
  );
}
